(() => {
  "use strict";

  var n = {
      799: (n, o, l) => {
        l.d(o, {
          Z: () => t
        });
        const t = {
          getVariant: function (n, o) {
            return function (l) {
              var t = l.variant;
              return n[t] ? n[t] : n[o || "default"];
            };
          }
        };
      },
      3160: (n, o, l) => {
        l.d(o, {
          h: () => t
        });
        var t = ((0, l(5834).system)({
          gap: {
            property: "gap",
            scale: "space"
          },
          rowGap: {
            property: "rowGap",
            scale: "space"
          },
          columnGap: {
            property: "columnGap",
            scale: "space"
          }
        }), ["display", "width", "height", "overflow", "size", "color", "opacity"]);
      },
      4702: n => {
        n.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
      },
      6689: n => {
        n.exports = require("react");
      },
      7518: n => {
        n.exports = require("styled-components");
      },
      5834: n => {
        n.exports = require("styled-system");
      }
    },
    o = {};
  function l(t) {
    var e = o[t];
    if (void 0 !== e) return e.exports;
    var r = o[t] = {
      exports: {}
    };
    return n[t](r, r.exports, l), r.exports;
  }
  l.n = n => {
    var o = n && n.__esModule ? () => n.default : () => n;
    return l.d(o, {
      a: o
    }), o;
  }, l.d = (n, o) => {
    for (var t in o) l.o(o, t) && !l.o(n, t) && Object.defineProperty(n, t, {
      enumerable: !0,
      get: o[t]
    });
  }, l.o = (n, o) => Object.prototype.hasOwnProperty.call(n, o), l.r = n => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(n, "__esModule", {
      value: !0
    });
  };
  var t = {};
  (() => {
    l.r(t), l.d(t, {
      Button: () => T,
      default: () => C
    });
    var n,
      o,
      e,
      r,
      u,
      i,
      d,
      a,
      v,
      s,
      c,
      f,
      b,
      p,
      m,
      h,
      y = l(4702),
      g = l.n(y),
      x = l(6689),
      w = l.n(x),
      z = l(7518),
      k = l.n(z),
      V = l(5834),
      _ = l(3160),
      P = l(799),
      j = {
        default: (0, z.css)(n || (n = g()(["\n    border-width: 3px;\n    border-style: solid;\n  "]))),
        outlined: (0, z.css)(o || (o = g()(["\n    background-color: transparent;\n    border-style: solid;\n    border-width: 3px;\n  "]))),
        text: (0, z.css)(e || (e = g()(["\n    border: none;\n    background-color: transparent;\n    /**\n     * Paddings and font-weight are handled by typeVariant, not by size, \n     * because text button sizing and font-weight logic differs from default and outlined variants\n     */\n    padding: 0;\n    font-weight: ", ";\n  "])), function (n) {
          var o,
            l,
            t = n.theme;
          return (null == t || null === (o = t.buttons) || void 0 === o || null === (l = o.fontWeights) || void 0 === l ? void 0 : l.textVariant) || 700;
        })
      },
      O = {
        default: {
          primary: (0, z.css)(r || (r = g()(["\n      color: ", ";\n      border-color: ", ";\n      background-color: ", ";\n\n      &:hover {\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      &:active {\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      &:disabled {\n        border-color: ", ";\n        background-color: ", ";\n      }\n    "])), function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.color;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.default;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.default;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.hover;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.hover;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.active;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.active;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.disabled;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.disabled;
          }),
          secondary: (0, z.css)(u || (u = g()(["\n      color: ", ";\n      border-color: ", ";\n      background-color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n\n      &:active {\n        color: ", ";\n      }\n\n      &:disabled {\n        color: ", ";\n      }\n    "])), function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.color;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.default;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.default;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.hover;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.active;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.default) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.disabled;
          })
        },
        outlined: {
          primary: (0, z.css)(i || (i = g()(["\n      color: ", ";\n      border-color: ", ";\n\n      &:hover {\n        color: ", ";\n        border-color: ", ";\n      }\n\n      &:active {\n        color: ", ";\n        border-color: ", ";\n      }\n\n      &:disabled {\n        color: ", ";\n        border-color: ", ";\n      }\n    "])), function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.default;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.default;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.hover;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.hover;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.active;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.active;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.disabled;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.disabled;
          }),
          secondary: (0, z.css)(d || (d = g()(["\n      color: ", ";\n      border-color: ", ";\n\n      &:hover {\n        color: ", ";\n        border-color: ", ";\n      }\n\n      &:active {\n        color: ", ";\n        border-color: ", ";\n      }\n\n      &:disabled {\n        color: ", ";\n        border-color: ", ";\n      }\n    "])), function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.default;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.default;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.hover;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.hover;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.active;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.active;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.disabled;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.outlined) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.disabled;
          })
        },
        text: {
          primary: (0, z.css)(a || (a = g()(["\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n\n      &:active {\n        color: ", ";\n      }\n\n      &:disabled {\n        color: ", ";\n      }\n    "])), function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.text) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.default;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.text) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.hover;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.text) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.active;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.text) || void 0 === l || null === (t = l.primary) || void 0 === t ? void 0 : t.disabled;
          }),
          secondary: (0, z.css)(v || (v = g()(["\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n\n      &:active {\n        color: ", ";\n      }\n\n      &:disabled {\n        color: ", ";\n      }\n    "])), function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.text) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.default;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.text) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.hover;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.text) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.active;
          }, function (n) {
            var o,
              l,
              t,
              e = n.theme;
            return null == e || null === (o = e.buttons) || void 0 === o || null === (l = o.text) || void 0 === l || null === (t = l.secondary) || void 0 === t ? void 0 : t.disabled;
          })
        }
      },
      M = {
        small: (0, z.css)(s || (s = g()(["\n    padding: 5px 20px;\n    font-weight: ", ";\n  "])), function (n) {
          var o,
            l,
            t = n.theme;
          return (null == t || null === (o = t.buttons) || void 0 === o || null === (l = o.fontWeights) || void 0 === l ? void 0 : l.small) || 600;
        }),
        default: (0, z.css)(c || (c = g()(["\n    padding: 9px 20px;\n    font-weight: ", ";\n  "])), function (n) {
          var o,
            l,
            t = n.theme;
          return (null == t || null === (o = t.buttons) || void 0 === o || null === (l = o.fontWeights) || void 0 === l ? void 0 : l.default) || 600;
        }),
        large: (0, z.css)(f || (f = g()(["\n    padding: 14px 20px;\n    font-weight: ", ";\n  "])), function (n) {
          var o,
            l,
            t = n.theme;
          return (null == t || null === (o = t.buttons) || void 0 === o || null === (l = o.fontWeights) || void 0 === l ? void 0 : l.large) || 700;
        })
      },
      S = {
        small: (0, z.css)(b || (b = g()(["\n    font-size: 10px;\n  "]))),
        default: (0, z.css)(p || (p = g()(["\n    font-size: 14px;\n  "]))),
        large: (0, z.css)(m || (m = g()(["\n    font-size: 18px;\n  "])))
      };
    const W = k().span(h || (h = g()(["\n  display: block;\n  text-align: center;\n  white-space: nowrap;\n  font-family: ", ";\n  line-height: normal;\n  color: inherit;\n\n  ", "\n"])), function (n) {
      var o,
        l = n.theme;
      return null == l || null === (o = l.fonts) || void 0 === o ? void 0 : o.default;
    }, function (n) {
      var o = n.size;
      return P.Z.getVariant(S)({
        variant: o
      });
    });
    var Z,
      q,
      G = k().button.withConfig({
        shouldForwardProp: function (n, o) {
          return !_.h.includes(n) && o(n);
        }
      })(Z || (Z = g()(["\n  // button reset properties\n  cursor: pointer;\n  outline: none;\n  text-decoration: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  && {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n  }\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  text-align: center;\n\n  // order of these is important for text typeVariant to override padding\n  ", "\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n"])), function (n) {
        var o = n.size;
        return P.Z.getVariant(M)({
          variant: o
        });
      }, P.Z.getVariant(j), function (n) {
        var o = n.variant,
          l = n.color;
        return P.Z.getVariant(O[o], "primary")({
          variant: l
        });
      }, function (n) {
        return n.disabled && (0, z.css)(q || (q = g()(["\n      cursor: not-allowed;\n    "])));
      }, V.width),
      T = function (n) {
        var o = n.as,
          l = n.dataTestId,
          t = n.form,
          e = n.children,
          r = n.type,
          u = n.onClick,
          i = n.variant,
          d = void 0 === i ? "default" : i,
          a = n.color,
          v = void 0 === a ? "primary" : a,
          s = n.size,
          c = void 0 === s ? "default" : s,
          f = n.fullWidth,
          b = n.disabled,
          p = n.width;
        return w().createElement(G, {
          as: o,
          type: r,
          onClick: u,
          variant: d,
          color: v,
          size: c,
          disabled: b,
          width: f ? "100%" : p,
          "data-testid": l,
          form: t
        }, "string" == typeof e ? w().createElement(W, {
          size: c
        }, e) : e);
      };
    const C = T;
  })();
  var e = exports;
  for (var r in t) e[r] = t[r];
  t.__esModule && Object.defineProperty(e, "__esModule", {
    value: !0
  });
})();